import { render, staticRenderFns } from "./ServiceProviderList.vue?vue&type=template&id=297a2421&scoped=true&"
import script from "./ServiceProviderList.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderList.vue?vue&type=style&index=0&id=297a2421&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297a2421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VContainer,VDataTable,VIcon,VSelect,VSpacer,VTextField})
